import { Platform } from 'ionic-angular';

import { Injectable } from '@angular/core';

import { Http } from '@angular/http';

import 'rxjs/Rx';

import { Observable } from 'rxjs/Observable';

import { BackgroundGeolocation, Push } from 'ionic-native';

import { UserData } from '../../providers/user-data';

@Injectable()

export class Location {



  constructor(public platform: Platform, public http: Http) {



  }
 


startTracking(user :any) {


let config = {
 stationaryRadius: 2,
  distanceFilter: 5,
  desiredAccuracy: 10,
  debug: false,
  locationProvider: 1,
  interval: 10000,
  fastestInterval: 1000,
  activitiesInterval: 1000,
  stopOnTerminate: false,
  startOnBoot: true,
  startForeground: true,
  stopOnStillActivity: true,
  activityType: 'AutomotiveNavigation',
  syncThreshold: 100,
  saveBatteryOnBackground: true,
  maxLocations: 100,
url: 'http://www.letpco.co.uk/api/v1/geoapi?authkey='+user,
syncUrl: 'http://www.letpco.co.uk/api/v1/geoapi?authkey='+user,
notificationTitle: 'Letpco Running',
    notificationText: 'Connected with Server',
    notificationIconColor: '#FEDD1E',
    notificationIconLarge: 'mappointer_large',
    notificationIconSmall: 'mappointer_small'
     };



  var callbackFn = function(location) {

    };
 
    var failureFn = function(error) {
      
alert('Network Error Check Wifi / Mobile Data');

    };

BackgroundGeolocation.configure(callbackFn,failureFn,config);

BackgroundGeolocation.start();




 var push = Push.init({
        android: {
          senderID: "600544786796"
        },
        ios: {
          alert: "true",
          badge: true,
          sound: 'false'
        },
        windows: {}
      });


      push.on('registration', (data) => {

this.http.get("http://www.letpco.co.uk/api/v1/push?authkey="+user+"&push="+data.registrationId)
        .subscribe(data => {
         alert('connected to LetPCO');
        }, error => {
        });
      });

      push.on('notification', (data) => {
        alert(data.title + ' ' + data.message );
      });

      push.on('error', (e) => {
      alert('Server Message not working');
      });

// BackgroundGeolocation.showLocationSettings();



}

stopTracking() {


 BackgroundGeolocation.stop();

}


checkTracking(username) {


}




 
}